import script from "./NewsfeedPageCreator.vue?vue&type=script&setup=true&lang=js"
export * from "./NewsfeedPageCreator.vue?vue&type=script&setup=true&lang=js"

import "./NewsfeedPageCreator.vue?vue&type=style&index=0&id=16981996&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-16981996"]])

export default __exports__